export const Constant = {
  // tslint:disable-next-line: max-line-length
  emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};
export const emptyFields = {
  NA: 'N/A'
};
export const shareLink = {
  email:'Email',
  sms:'Phone'
}
 export const appCodes = {
  adbUATNew:'29',
  otherappCode:'65'
};
export const offerTitle = {
  update: 'Update Offer',
  create: 'Create Offer'
}
export const AllOption = [
  { value: 0, label: 'All' },
];
export const Country = {
  alpha_2_code: 'SG',
  alpha_3_code: 'SGP',
  currency_code: 'SGD',
  name: 'Singapore',
  symbol: '$',
  countrySymbol: 'SG$',
  telephone_code: '+65'
};
export const KycStatus = {
  verified: 'verified',
  rejected: 'rejected',
  approved: 'approved',
  submitted: 'submitted',
  notsubmitted: 'notsubmitted',
  resubmitted: 'resubmitted',
  incomplete: 'incomplete',
  underreview: 'underreview',
  expired: 'expired',
  nearExpiry: 'nearexpiry'
};
export const KycStatusText = {
  verified: 'Verified',
  rejected: 'Rejected',
  approved: 'Approved',
  submitted: 'submitted',
  NotSubmitted: 'Not Submitted',
  resubmitted: 'Re submitted',
  incomplete: 'Incomplete',
  underreview: 'Under Review',
  expired: 'Expired',
  nearExpiry: 'Near Expiry'
};
export const Tier = {
  tier1: 1,
  tier2: 2,
  tier3: 3
};
export const Address = {
  "24": "304 Orchard Rd, #02-19, Singapore 238863",
  "32": "345 Geylang Road, Pavilion Square, #01-12, Singapore 389366",
  "31": "345 Geylang Road, Pavilion Square, #01-12, Singapore 389366",
  "29": "Asian Development Bank,\n 6 ADB Avenue,\n Mandaluyong City",
  "30": "Asian Development Bank,\n 6 ADB Avenue,\n Mandaluyong City",
  "25": "86/87/88 Lucky Plaza, 304 Orchard Road, Singapore 238863",
  "33": "Aljunied MRT Station, #01-10 Lor 25 Geylang, 388310",
  "": "831 Lipsum dolar Fountain Valley, CA 92708 Singapore",
  "20": "304 Orchard Rd, #02-19, US 238863"
}
export const TierName = {
  tier1: 'Tier 1',
  tier2: 'Tier 2',
  tier3: 'Tier 3'
};
export const TierOptions = [
  { value: 1, label: 'Tier 1' },
  { value: 2, label: 'Tier 2' }
];
export const productTypeAllOptions = [
  { value: '', label: "All" },
  { value: 'prepaid', label: "Prepaid" },
  { value: 'postpaid', label: "Postpaid" },
  { value: 'government services', label: "Government Services" },
];
export const UsersType = {
  admin: 'admin',
  appUser: 'appuser',
  merchantUser: 'merchant',
  locationUser: 'location-user',
  locationManager: 'location-manager',
  agent: 'agent',
};
export const PaymentModes = {
  0: "QR Code",
  1: "Card   ",
  2: "Cash   ",
  3: "Adjustment"
}
export const PaymentModeIcons = {
  0: "qrcode",
  1: "credit-card",
  2: "bank",
  3: ""
}
export const statusForProduct = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];
export const productTypeOptions = [
  { value: 'prepaid', label: "Prepaid" },
  { value: 'postpaid', label: "Postpaid" },
  { value: 'government services', label: "Government Services" },
];
export enum Status {
  Deleted = 0,
  Active = 1,
  InActive = 2,
  Locked = 3,
  Flagged = 4,
  UnFlagged = 5,
  ClosureRequested = 6,
  Blocked = 7,
  Hold = 8,
}
export const StatusTextColor = {
  1: "green",
  2: "magenta",
  8: "red",
};
export const UsersTypeText = {
  admin: 'Admin User',
  appUser: 'App User',
  merchantUser: 'Merchant User',
  locationUser: 'Location User',
  locationManager: 'Location Manager',
  agent: 'Agent User',
};
export const UserStatus = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  // Locked: 3,
  Flagged: 4,
  UnFlagged: 5,
  ClosureRequested: 6,
  Blocked: 7,
};
export const StatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  Locked: "Locked",
  Flagged: "In Review",
  UnFlagged: "UnFlagged",
  ClosureRequested: "Closure Requested",
  Blocked: "Blocked",
};
export const UserStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  // Locked: "Locked",
  Flagged: "In Review",
  UnFlagged: "UnFlagged",
  ClosureRequested: "Closure Requested",
  Blocked: "Blocked",
};
export const StatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  Locked: "red",
  Flagged: "cyan",
  UnFlagged: "blue",
  ClosureRequested: "red",
  Blocked: "red",
};
export const UserStatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  // Locked: "red",
  Flagged: "cyan",
  UnFlagged: "blue",
  ClosureRequested: "red",
  Blocked: "red",
};
export const OrderStatus = {
  Created: 1,
  Accepted: 2,
  Pending: 3,
  Delivered: 4,
  Rejected: 5,
  Cancelled: 6,
  PaymentPending: 7
};
export const OrderStatusColor = {
  Created: "magenta",
  Accepted: "green",
  Pending: "red",
  // Locked: "red",
  Delivered: "cyan",
  Rejected: "blue",
  Cancelled: "red",
  PaymentPending: "red",
};

export const OrderStatusText = {
  Created: 'Order Created',
  Accepted: 'Order Accepted',
  Pending: 'Order Pending',
  Delivered: 'Order Delivered',
  Rejected: 'Order Rejected',
  Cancelled: 'Order Cancelled',
  PaymentPending: 'Payment Pending'
};
export const OrderStatusOptions = [
  { value: 1, label: 'Order Created' },
  { value: 2, label: 'Order Accepted' },
  { value: 3, label: 'Order Pending' },
  { value: 4, label: 'Order Delivered' },
  { value: 5, label: 'Order Rejected' },
  { value: 6, label: 'Order Cancelled' },
  { value: 7, label: 'Payment Pending' },
];
export const TopupOptions = [
  { value: 'mobile_no', label: 'Mobile No' },
  { value: 'account_no', label: 'Account No' }
];

export const CurrencySymbols = {
  Singapore: '$',
  India: '₹',
  Philippines: '₱'
};
export const MerchantCategoryList = [
  'Lifestyle', 'Medical', 'Food', 'Others', 'Travel', 'Household', 'Entertainment'
];

export const weekDays = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];
export const TransactionTypeOptions = [
  { value: 4, label: 'Merchant Pay' },
  { value: 6, label: 'Refund' },
  { value: 7, label: 'Settlement' },
];
export const ReportTerminals = {
  merchantTransactionReport: 'Merchant Transaction Report',
  merchantTransactionReportNew: 'Merchant Transaction Report New',
  merchantSettlementReport: 'Merchant Settlement Report',
  settledTransactions: 'Settlement Transactions',
  merchantDailySummary: 'Merchant Transactions Daily Summary',
  merchantTransactionsForSummary: 'Daily Summary Transactions',
  merchantProductReport: "Merchant Product Report",
  merchantRequestedPaymentList: "Merchant Requested Payment List",
  merchantOrderDetails:'Merchant Order Details',
  redeemedVoucherReport: "Redeemed Voucher Report",
  redeemedVoucherReport2: "Redeemed Voucher Reports",

};
export const ReportTerminal ={
  SettlementTransactions:6,
  MerchantBoardTransactionReportNew:11,
  MerchantTransactionsDailySummary:12
}
export const OrdersMobOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "display_name", label: "Display Name" },
];

export const AppCode = [
  { value: '*', label: 'ALL' },
  { value: '01', label: 'DEV' },
  { value: '24', label: 'JDee' },
  { value: '04', label: 'SandBox UAT' },
  { value: '25', label: 'ADB UAT' }
];

export const UATAppCode = [
  { value: '*', label: 'ALL' },
  { value: '04', label: 'SandBox UAT' },
  { value: '25', label: 'ADB UAT' },

];
export const InstanceName = {
  dev: "DEV",
  uatSG: "uatSG",
  uatPHP: "uatPHP",
  liveSG: "LIVESG",
  livePHP: "livePHP",
  uatCAD: 'uatCAD',
  liveCAD: 'LIVECAD'
};
export const appCodeValue = {
  all: '*'
};
export const AppCodeName = {
  all: 'ALL',
  dev: 'DEV',
  test: 'TEST',
  sandboxUAT: 'SandBox UAT',
  adbUAT: 'ADB UAT',
  BeamAndGo: 'Beam&Go',
  ADBPAY: 'ADB Pay',
  Zhongguo: 'Zhongguo',
};
export const MerchantStatus = {
  active: 1,
  inActive: 2
};
export const MerchantStatusText = {
  active: 'Active',
  inActive: 'In Active'
};
export const SettlementFrequency = {
  on: true,
  off: false
};
export const SettlementFrequencyStatusText = {
  on: 'On',
  off: 'Off'
};
export const SettlementStatus = {
  unSettled: false,
  settled: true
};
export const settlementStatusText = {
  settled: 'Settled',
  unSettled: 'Un Settled',
};
export const tagColorForSettlementStatus = {
  settled: 'red',
  unSettled: 'green',
};
export const BusinessModel = [
  'Retail Store', 'E-commerce (website)', 'Trade/Office', 'Others'
];
export const MonthDates = [
  // tslint:disable-next-line: max-line-length
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'
];
export const SettlementDocumentStatus = {
  open: 0,
  paid: 1,
  hold: 2,
  failed: 3,
  processing: 4

};
export const textForSettlementDocumentStatus = {
  open: 'Open',
  paid: 'Paid',
  hold: 'Hold',
  failed: 'Failed',
  processing: 'Processing',
};
export const settlementDocumentStatusOptions = [
  { value: 0, label: 'Open' },
  { value: 1, label: 'Paid' },
  { value: 3, label: 'Failed' },
  { value: 4, label: 'Processing' }
];
export const settlementStatusOptions = [
  { value: true, label: 'Settled' },
  { value: false, label: 'Un Settled' },
];
export const AvailableOptions = [
  { value: true, label: 'Available' },
  { value: false, label: 'Un Available' }
]
export const tagColorForsettlementDocumentStatus = {
  open: 'green',
  paid: 'red',
  hold: 'red',
  failed: 'red',
  processing: 'purple'
};
export const AvailableColor = {
  true: 'green',
  false: 'red'
}
export const AssignedColor = {
  true: 'green',
  false: 'red'
}
export const appSettings = {
   Address:'receipt_address',
   Nationality: 'nationality',
}
export const AllUserTypeOptions = [
  { value: 'admin', label: 'Admin' },
  { value: 'finance', label: 'Finance' },
  { value: 'agent', label: 'Agent' },
  { value: 'merchant', label: 'Merchant User' },
  { value: 'location-user', label: 'Location User' },
  { value: 'location-manager', label: 'Location Manager' }
];
export const settlementTypes = [
  { value: 'auto', label: 'Auto' },
  { value: 'demand', label: 'Demand' },
];
export const SettlementType = {
  auto: 'auto',
  demand: 'demand'
};
export const TransactionAccountTypes = {
  refund: 'REFUND',
  settlement: 'SETTLEMENT',
  qrPayment: 'PAYMENT',
  externalPayment: 'EXTERNAL PAYMENT',
  "MONTHLY-TRANSFER-FEE":"MONTHLY-TRANSFER-FEE"
};
export const TransactionAccountTypeOptions = [
  { value: 'REFUND', label: 'Refund' },
  { value: 'SETTLEMENT', label: 'Settlement' },
  { value: 'PAYMENT', label: 'Payment' },
];
export const TransactionAccountTypeOptionsNew = [
  { value: "REFUND", label: "Refund" },
  { value: "SETTLEMENT", label: "Settlement" },
  { value: "PAYMENT", label: "Payment" },
  { value:"MONTHLY-TRANSFER-FEE",label:"Monthly Transfer Fee"}
];
export const StatusOptions = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'In Active' }
]
export const TransactionAccountTypesText = {
  refund: 'REFUND',
  settlement: 'SETTLEMENT',
  qrPayment: 'PAYMENT',
  externalPayment: 'PAYMENT',
  "MONTHLY-TRANSFER-FEE":"MONTHLY TRANSFER FEE"
};
export const TagColorForTransactionAccountType = {
  refund: 'red',
  settlement: 'red',
  qrPayment: 'green',
  externalPayment: 'green',
  "MONTHLY-TRANSFER-FEE":"purple"
};
export const attachmentTypes = {
  user: 'user',
  transaction: 'transaction',
  merchantSettlement: 'merchant-settlement',
};
export const attachmentCode = {
  attachment: 'attachment',
}
export const commentsType = {
  merchantSettlement: 'merchant-settlement',
  transaction: 'transaction',
};
export const PaymentMethod = {
  Wallet: 'Wallet',
  PayNow: 'PayNow',
  Card: 'Card',
  GiftCard: 'Gift Card',
  BankTransfer: 'BankTransfer',
  Cash: 'Cash',
  Cheque: 'Cheque',
  Voucher: 'Voucher',
  BillPaymentTopup: 'BillPaymentTopup',
  ETransfer : 'ETransfer'

};
export const PaymentMethodText = {
  Wallet: 'Wallet',
  PayNow: 'PayNow',
  Card: 'Card',
  GiftCard: 'Gift Card',
  BankTransfer: 'BankTransfer',
  Cash: 'Cash',
  Cheque: 'Cheque',
  Voucher: 'Voucher',
  BillPaymentTopup: 'BillPayment Topup',
  ETransfer : 'ETransfer'
};
export const PaymentMethodColor = {
  Wallet: "magenta",
  PayNow: "green",
  Card: "red",
  GiftCard: "cyan",
  BankTransfer: "cyan",
  Cash: "red",
  Cheque: "orange",
  Voucher: 'yellow',
  BillPaymentTopup: '#6E96A8',
  ETransfer : '#590559'
};
export const SettlementBy = {
  Flexm: 'FlexM',
  Stripe: 'Stripe'
};
export const SettlementByText = {
  Flexm: 'FlexM',
  Stripe: 'Stripe'
};
export const SettlementByColor = {
  Flexm: "magenta",
  Stripe: "green",
};
export const PaymentMethodOptions = [
  { value: 'Wallet', label: 'Wallet' },
  { value: 'PayNow', label: 'Pay Now' },
  { value: 'Card', label: 'Card' },
  { value: 'Gift Card', label: 'Gift Card' },
  { value: 'BankTransfer', label: 'Bank Transfer' },
  { value: 'Cash', label: 'Cash' },
  { value: 'Cheque', label: 'Cheque' },
  { value: 'Voucher', label:'Voucher'}
];
export const currencyForAppCode = [
  { currency: "SGD", appCode: "*", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "01", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "02", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "04", country: "Singapore", symbol: "$" },  
  { currency: "SGD", appCode: "10", country: "Singapore", symbol: "$" },
  { currency: "CAD", appCode: "11", country: "Canada", symbol: "$" },
  { currency: "SGD", appCode: "12", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "13", country: "Singapore", symbol: "$" },
  { currency: "USD", appCode: "20", country: "United States of America", symbol: "$" },
  { currency: "SGD", appCode: "21", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "23", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "24", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "25", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "26", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "28", country: "Singapore", symbol: "$" },
  { currency: "PHP", appCode: "29", country: "Philippines", symbol: "₱" },
  { currency: "PHP", appCode: "30", country: "Singapore", symbol: "₱" },
  { currency: "SGD", appCode: "31", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "32", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "33", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "34", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "35", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "36", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "37", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "38", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "39", country: "Singapore", symbol: "$" },

];
export const currencyForALLAppcode = [
  { instance: "DEV", symbol: '$' },
  { instance: "uatSG", symbol: '$' },
  { instance: "uatPHP", symbol: '₱' },
  { instance: "LIVESG", symbol: '$' },
  { instance: "livePHP", symbol: '₱' },
  { instance: "uatCAD", symbol:'$'},
  { instance: "LIVECAD", symbol:'$'}
];

export const availableStatus = {
  unAvailable: false,
  available: true
};
export const PaymentModeText = {
  cash: "Cash",
  adjustment: "Adjustment",
  card: "Card",
  qrcord: "QR Code",
  Wallet:"Wallet"
}
export const availableStatusText = {
  available: 'Available',
  unAvailable: 'Un Available',
};
export const tagColorForAvailableStatus = {
  unAvailable: 'red',
  available: 'green',
};
export const tagColorForPaymentModes = {
  cash: "magenta",
  adjustment: "cyan",
  card: "green",
  qrcord: "purple",
  Wallet:"blue"
}
// UserTypes
export const UserTypes = {
  admin: "admin",
  merchant: "merchant",
  appUser: "appuser",
  locationUser: "location-user",
  locationManager: "location-manager",
  agent: "agent",
  kycBoardUser: "kyc-board-user",
};
export const UserTypeText = {
  admin: "Admin",
  merchant: "Merchant",
  appUser: "App User",
  locationUser: "Location User",
  locationManager: "Location Manager",
  agent: "Agent",
  kycBoardUser: "KYC Board User",
};
export const UserTypeColor = {
  admin: "magenta",
  merchant: "cyan",
  appUser: "green",
  locationUser: "purple",
  locationManager: "blue",
  agent: "orange",
  kycBoardUser: "purple",
};
export const MerchantOrderStatus = {
  Created: "created",
  Confirm: "confirm",
  Accepted: "accepted",
  InProcess: "inprocess",
  ReadyForPickup:"readyforpickup",
  ReadyToPickup: "readytopickup",
  Rejected: "rejected",
  Cancelled: "cancelled",
  Delivered: "delivered"
};
export const DeliveryMethod = {
  'walk-in': "Walk In",
  'door-delivery': "Door Delivery",
  'pick-up':'Pick Up',
};
export const DeliveryMethodValues = {
  walkin: "walk-in",
  doordelivery: "door-delivery"
};
export const MerchantOrderStatusColor = {
  Created: "magenta",
  Confirm: "blue",
  Accepted: "green",
  InProcess: "orange",
  ReadyForPickup:"purple",
  ReadyToPickup: "red",
  Delivered: "cyan",
  Rejected: "blue",
  Cancelled: "red",
};

export const MerchantOrderStatusText = {
  Created: "Created",
  Confirm: "Confirm",
  Accepted: "Accepted",
  InProcess: "InProcess",
  ReadyForPickup:"Ready For Pickup",
  ReadyToPickup: "Ready To Pickup",
  Rejected: "Rejected",
  Cancelled: "Cancelled",
  Delivered: "Delivered"
};
export const MerchantOrderStatusOptions = [
  { value: 'created', label: 'Created' },
  //{ value: 'confirm', label: 'Confirm' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'inprocess', label: 'In Process' },
  { value: 'readyforpickup', label: 'Ready For Pickup' },
  //{ value: 'rejected', label: 'Rejected' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'cancelled', label: 'Cancelled' },

];
export const MerchantPaymentStatus = {
  Processing: "processing",
  Paid: "paid",
  Cancelled: "canceled",
  Expired: "expired",
};
export const MerchantPaymentStatusColor = {
  Processing: "orange",
  Paid: "green",
  Cancelled: "red",
  Expired: "cyan"
};
export const MerchantPaymentText = {
  Processing: 'processing',
  Paid: 'paid',
  Cancelled: 'cancelled',
  Expired: 'expired'

};

export const voucherType = {
  Cash: "cash",
  Merchant: "merchant",
};

export const voucherTypeText = {
  Cash: "Cash",
  Merchant: "Merchant",
};

export const voucherTypeColor = {
  Cash: "cyan",
  Merchant: "orange",
};
export const purchaseTypeOptions = [
  { label: "Points", value: "points" },
  { label: "Price", value: "price" },
  { label: "Free", value: "free" },
  { label: "Display", value: "display" },
];

export const purchaseType = {
  Points: "points",
  Price: "price",
  Free: "free",
  Display: "display",
};

export const purchaseTypeText = {
  Points: "Points",
  Price: "Price",
  Free: "Free",
  Display: "Display",
};

export const purchaseTypeColor = {
  Points: "magenta",
  Price: "green",
  Free: "orange",
  Display: "blue"
};

export const voucherTypeOptions = [
  { label: "Cash", value: "cash" },
  { label: "Merchant", value: "merchant" },
];
export const DeliveryMethods = [
  { value: 'walk-in', label: 'Walks In' },
  { value: 'door-delivery', label: 'Door delivery' }
];

export const voucherStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  NotIssued: "Not Issued",
  Expired: "Expired",
  Redeemed: "Redeemed",
};

export const voucherStatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  NotIssued: "red",
  Expired: "cyan",
  Redeemed: "blue",
};

export const VoucherStatus = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  NotIssued: 3,
  Expired: 4,
  Redeemed: 5,
};

export const voucherStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 3, label: "Not Issued" },
  { value: 4, label: "Expired" },
  { value: 5, label: "Redeemed" },
];

export const voucherStatusOptions2 = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 3, label: "Not Issued" },
];

export const voucherCodeStatus = {
  newStatus: "redeemed",
  oldStatus: "active",
};

export const voucherCodeStatusColor = {
  oldStatus: "green",
  newStatus: "red",
};
export const voucherStatusCodeText = {
  newStatus: "redeemed",
  oldStatus: "active",
};

export const FooterStaticValue={
  encryptedAmount:"***"
};

export const gstColumnName = {
  gst:'FlexM GST',
  hst:'FlexM GST / HST'
 };